import { ModalData } from './ModalData'

export class GoalData {
    id: number
    title: string
    position: [number, number]

    header: string
    overview: string

    progress: string
    objectives: string
    community: string

    image: string

    constructor(data: IGoalData) {
        this.id = data.id
        this.title = data.title
        try {
            let p = data.position.split(',')?.map((s) => parseInt(s))
            this.position = [p[0], p[1]]
        } catch {
            throw 'position parsed incorrectly'
        }

        this.header = data.header
        this.overview = data.overview
        this.progress = data.progress
        this.objectives = data.objectives
        this.community = data.community
        if(data.image == "") {
            this.image = './dssd.png'  //default image when one doesn't exist in the spread sheet
        } else {
            this.image = data.image
        }
        
    }
}

export function toModalData(data: GoalData): ModalData {
    return {
        items: [
            {
                summary: data.header,
                body: data.overview,
            },
            {
                summary: 'How are we measuring progress towards this outcome?',
                body: data.progress,
            },
            {
                summary: 'Which RVAgreen 2050 objectives will get us there?',
                body: data.objectives,
            },
            {
                summary: 'How does this support community priorities?',
                body: data.community,
            },
        ],
    }
}

export interface IGoalData {
    id: number
    title: string
    position: string

    header: string
    overview: string

    progress: string
    objectives: string
    community: string

    image: string
}
